<template>
    <div
         :style="`
         width:100%;
         padding-right:${bodypadding}px;
         padding-left:${bodypadding}px;
         padding-top:${d.padding}px;
         padding-bottom:${d.padding}px;
         text-align:${d.textAlign};`">

        <button :style="`
           width:${d.buttonwidth}px;
           height:${d.buttonheight}px;
           border-radius:${d.buttonborderradius}px;
           background-color:${d.buttonbackgroundcolor};
           color:${d.buttoncolor};`"
        >
            {{d.text}}
        </button>


    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active','bodypadding'],
    components: {},
    name: "BButton",
    data() {
      return {}
    },
    computed:{
      ...mapState(['icons','org'])
    }
  }
</script>

<style scoped>

</style>